import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconFlagNL = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  const iconTitle = title ?? 'Netherlands'
  const iconSize = size ?? 16
  const iconColor = color ?? theme.colors.contentPrimary

  return (
    <Icon
      viewBox="0 0 24 24"
      ref={ref}
      title={iconTitle}
      size={iconSize}
      color={iconColor}
      overrides={overrides}
    >
      <title>{iconTitle}</title>
      <rect x="3" y="6" width="18" height="12" rx="2" fill="#FFFFFF" />
      <path d="M5 6h14a2 2 0 0 1 2 2v2H3V8a2 2 0 0 1 2-2z" fill="#E22D2D" />
      <path d="M3 14h18v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2z" fill="#1E56A0" />
      <rect
        x="3"
        y="6"
        width="18"
        height="12"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.35"
      />
    </Icon>
  )
}

IconFlagNL.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconFlagNL
